import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DirectivesModule } from '@common/directives/directives.module';
import { UIModule } from '@common/UI/UI.module';
import { CoreModule } from '@core/core.module';
import { ExportsComponent } from './exports/exports.component';
import { ImportsComponent } from './imports/imports.component';
import { PricesComponent } from './prices/prices.component';
import { NgxLoadingModule } from 'ngx-loading';



@NgModule({
  declarations: [
    ExportsComponent,
    ImportsComponent,
    PricesComponent
  ],
  imports: [
    CommonModule,
    NgxLoadingModule,
    CoreModule,
    DirectivesModule,
    UIModule,
  ]
})
export class OrdersModule { }
